import React, { useContext, useEffect, useState } from 'react';
import InsightMenuItem from './InsightMenuItem/InsightMenuItem';
import AccountFound from './AccountFound/AccountFound';
import PlayerInsightLoadingWithMessages from '../ArccosTile/Loading/PlayerInsightLoadingWithMessages';
import teeIcon from '../../assets/images/icons/tee.svg';
import flagIcon from '../../assets/images/icons/flag.svg';
import gappingIcon from '../../assets/images/icons/gapping.svg';
import analysisIcon from '../../assets/images/icons/analysis.svg';
import shortLongIcon from '../../assets/images/icons/short-long.svg';
import arrow from '../../assets/images/icons/arrow-left.svg';
import { insightsContext } from '../../context/insightsContext';
import Styles from './InsightMenu.module.scss';

const InsightMenu = (props) => {
  const {
    isTileView,
    toggleModal,
    tileText,
    fetchingAuthorInfo,
  } = props;
  const [isLoading, setLoading] = useState(false);
  const insights = useContext(insightsContext);
  const { state, dispatch } = insights;
  const {
    data,
    currentInsight,
    acceptedTerms,
    dataError,
    profile,
  } = state;

  const iconMap = {
    driverMiss: teeIcon,
    ironMiss: flagIcon,
    setGapping: gappingIcon,
    shortDistance: shortLongIcon,
    gameWeakness: analysisIcon,
  };

  const getIcon = (code) => {
    return iconMap[code] ?? '';
  };

  const scrollToTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const getViewInsightsButtonText = () => {
    return tileText?.viewInsightsFooterButtonTxt.replace('"{number_of_insights}"', data.length);
  };

  const getLastRoundDateAndLocationText = () => {
    const textWithReplacedDateAndLocation = tileText?.lastRoundDateAndLocation
      .replace('"{last_round_date}"', profile.lastRoundDate)
      .replace('"{last_round_location}"', profile.lastRoundCourseName);

    return textWithReplacedDateAndLocation;
  };

  const getLastRoundsPlayedText = () => {
    const textWithReplacedRoundsPlayed = tileText?.roundsPlayed.replace('"{rounds_played}"', profile?.rounds);

    return textWithReplacedRoundsPlayed;
  };

  return (
    <div className={isTileView
      ? `${Styles.insightMenuContainerTile} ${data
        && acceptedTerms
        && !isLoading ? Styles.insightMenuHeight : ''
      }` : ''}>
      {data
        && !isLoading
        && (
          <div>
            {acceptedTerms ? (
              <div>
                {isTileView && profile && (
                  <div className={Styles.userProfileInfo}>
                    {profile.rounds && (
                      <div className={Styles.roundsPlayed}>
                        {getLastRoundsPlayedText()}
                      </div>
                    )}
                    {profile.lastRoundDate
                      && profile.lastRoundCourseName
                      && (
                        <div className={Styles.roundLocationDate}>
                          {getLastRoundDateAndLocationText()}
                        </div>
                      )}
                  </div>
                )}
                <div className={`${Styles.insightMenu} ${isTileView ? Styles.tileView : ''}`}>
                  {data.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={isTileView ? Styles.insightMenuItem : null}
                      >
                        <InsightMenuItem
                          menuItem={item}
                          isActive={parseInt(index) === currentInsight}
                          isTileView={isTileView}
                          toggleModal={toggleModal}
                          icon={getIcon(item.code)}
                          onClick={() => {
                            if (isTileView) {
                              toggleModal();
                              scrollToTop();
                            }
                            if (!fetchingAuthorInfo) {
                              dispatch({ type: 'SET_INSIGHT', index: parseInt(index) });
                            }
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                {isTileView
                  && acceptedTerms
                  && (
                    <div className={Styles.footer}>
                      <button
                        className={Styles.openArccosAppBtn}
                        type='button'
                        onClick={() => {
                          toggleModal();
                          document.body.scrollTop = 0;
                          document.documentElement.scrollTop = 0;
                        }}>
                        {getViewInsightsButtonText()}
                        <img className={Styles.viewInsightsArrow} src={arrow} alt='arrow' />
                      </button>
                    </div>
                  )
                }
              </div>
            ) : (
              <AccountFound setLoading={setLoading} />
            )}
          </div>
        )
      }
      {dataError
        && (
          <div className={Styles.dataError}>
            {tileText?.noData.map((text, i) => {
              return (
                <div key={i}>
                  {text}
                </div>
              );
            })}
          </div>
        )
      }
      {isLoading && <PlayerInsightLoadingWithMessages setLoading={setLoading} />}
    </div >
  );
};

export default InsightMenu;
